import type { SVGAttributes } from 'react';

export type AppLogoProps = SVGAttributes<SVGSVGElement>;

export const AppLogo = ({ ...props }: AppLogoProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132 132" {...props}>
    <path
      fill="#00977d"
      d="M0 113.636v-95.37h.068C.91 8.042 9.466.015 19.909 0h92.182c10.452 0 18.976 8.046 19.822 18.266H132v95.37h-.057c-.772 10.293-9.359 18.396-19.852 18.396H19.909c-10.496 0-19.048-8.115-19.832-18.396H0Z"
    />
    <path
      fill="#fff"
      d="M110.544 46.662v-.015c12.002 32.675-7.579 66.664-45.864 66.773H.063c-.032-.437-.063-.86-.063-1.313V94.73h64.242c28.16 0 35.864-28.722 22.768-46.974-.781-.984-.109-2.531 1.204-2.531h20.018c1 0 1.875.562 2.312 1.437Zm21.394-28.05v.016c.031.437.062.859.062 1.312v17.377H67.539c-28.159 0-35.863 28.722-22.768 46.975.781.984.109 2.53-1.203 2.53H23.55a2.57 2.57 0 0 1-2.313-1.436C9.235 52.71 28.816 18.72 67.102 18.612h64.836Z"
    />
  </svg>
);
